import React from 'react';
import styled from 'styled-components';

const StyledInput = styled.input`
  display: none;
`;

interface Props {
  id: string;
  multiple: boolean;
  uploadDocumentRequest: Function;
  disabled: boolean;
}

export const InputFile = (props: Props) => {
  const { id, multiple, uploadDocumentRequest, disabled } = props;

  // Component method
  const handleFileUpload = (e: any) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      uploadDocumentRequest({
        file,
      });
    }
    e.target.value = null;
  };

  return (
    <StyledInput
      disabled={disabled}
      type="file"
      id={id}
      onChange={(e) => {
        handleFileUpload(e);
      }}
      multiple={multiple}
    />
  );
};
